/* eslint-disable complexity */
import React from "react";
import style from "./styles";
import PropTypes from "prop-types";
import { trackOmnitureClicks } from "static/staticData/omniture/omnitureUtils";
import { OMNITURE_LINK_NAME } from "static/staticData/omniture/trackingConstants";

const MoreLink = ({
  paddingTop = null,
  showMoreText = "Show More",
  omnitureTracking,
  className = "",
} = {}) => {
  const trackOmnitureClick = () => {
    if (omnitureTracking && omnitureTracking === "adp") {
      trackOmnitureClicks(OMNITURE_LINK_NAME.ADP.CONTINUE_READING);
    } else if (omnitureTracking && omnitureTracking === "TDP") {
      trackOmnitureClicks(OMNITURE_LINK_NAME.TDP.CONTINUE_READING);
    } else if (omnitureTracking && omnitureTracking === "CDP") {
      trackOmnitureClicks(OMNITURE_LINK_NAME.CDP.CONTINUE_READING);
    }
  };
  const mystyle = {
    paddingTop,
  };
  return (
    <>
      <style jsx>{style}</style>
      <div className="fade-out"></div>
      <p className={"show-more-link " + className} data-testid="component-moreLink" style={mystyle}>
        <button className={"linkButton " + className} onClick={() => trackOmnitureClick()}>
          {showMoreText}
        </button>
      </p>
    </>
  );
};
export { MoreLink };

MoreLink.propTypes = {
  paddingTop: PropTypes.string,
  showMoreText: PropTypes.string,
  omnitureTracking: PropTypes.string,
  className: PropTypes.string,
};
